import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue"

import { ref } from 'vue'
import { IonTabBar, IonTabButton, IonTabs, IonLabel, IonIcon, IonPage, IonRouterOutlet } from '@ionic/vue'
import { duplicateOutline, layersOutline, navigateCircleOutline } from 'ionicons/icons'

import { useRouter }  from 'vue-router'

import { useIncidenciaStore } from '@/stores/incidencia-store'
import { useIncidenciaList } from '@/modules/incidencia-list'

import { UserCredentials } from '@/models/UserCredentials'
import FormLoginModal from '@/components/FormLoginModal'


export default /*#__PURE__*/_defineComponent({
  __name: 'TabsPage',
  setup(__props) {

const router = useRouter()
const store = useIncidenciaStore()

const showModal = ref<boolean>(false)
const routeName = ref<string>()
const { needLogin } = useIncidenciaList()

const goCategories = () => {
  store.reset()
  router.push({ name: 'create' })
}

const goTab = async (name: string) => {
  routeName.value = name

  if (needLogin.value) showModal.value = true
  else await router.push({ name })
}

const saveUser = (user: UserCredentials) => {
  store.setUser(user)
  router.push({ name: routeName.value })
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(_unref(IonPage), null, {
    default: _withCtx(() => [
      _createVNode(_unref(IonTabs), null, {
        default: _withCtx(() => [
          _createVNode(_unref(IonRouterOutlet)),
          _createVNode(_unref(IonTabBar), { slot: "bottom" }, {
            default: _withCtx(() => [
              _createVNode(_unref(IonTabButton), {
                tab: "tab1",
                onClick: goCategories
              }, {
                default: _withCtx(() => [
                  _createVNode(_unref(IonIcon), { icon: _unref(duplicateOutline) }, null, 8, ["icon"]),
                  _createVNode(_unref(IonLabel), null, {
                    default: _withCtx(() => [
                      _createTextVNode("Nueva")
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              }),
              _createVNode(_unref(IonTabButton), {
                tab: "tab2",
                onClick: _cache[0] || (_cache[0] = ($event: any) => (goTab('list')))
              }, {
                default: _withCtx(() => [
                  _createVNode(_unref(IonIcon), { icon: _unref(layersOutline) }, null, 8, ["icon"]),
                  _createVNode(_unref(IonLabel), null, {
                    default: _withCtx(() => [
                      _createTextVNode("Tramitadas")
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              }),
              _createVNode(_unref(IonTabButton), {
                tab: "tab3",
                onClick: _cache[1] || (_cache[1] = ($event: any) => (goTab('map')))
              }, {
                default: _withCtx(() => [
                  _createVNode(_unref(IonIcon), { icon: _unref(navigateCircleOutline) }, null, 8, ["icon"]),
                  _createVNode(_unref(IonLabel), null, {
                    default: _withCtx(() => [
                      _createTextVNode("Plano")
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              })
            ]),
            _: 1
          })
        ]),
        _: 1
      }),
      _createVNode(_unref(FormLoginModal), {
        display: showModal.value,
        "onUpdate:display": _cache[2] || (_cache[2] = ($event: any) => ((showModal).value = $event)),
        onSave: saveUser
      }, null, 8, ["display"])
    ]),
    _: 1
  }))
}
}

})